import { render, staticRenderFns } from "./BankFooter.vue?vue&type=template&id=f99ea318&scoped=true&"
import script from "./BankFooter.vue?vue&type=script&lang=js&"
export * from "./BankFooter.vue?vue&type=script&lang=js&"
import style0 from "./BankFooter.vue?vue&type=style&index=0&id=f99ea318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99ea318",
  null
  
)

export default component.exports